var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Text } from 'react-native';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
let TextView = class TextView extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = (option) => {
            return typeof this.props.onClick === 'function' && this.props.onClick(option);
        };
    }
    render() {
        var _a;
        return (_jsx(Text, { style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, children: this.props.value.map((option, i) => (_jsx(AnimatedTextView, { textStyle: option.style, onPress: () => this.handleClick(option), children: option.text }, i))) }));
    }
};
TextView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.text,
        style: {
            container: {
                fontSize: 15,
                lineHeight: 20
            }
        }
    })
], TextView);
export { TextView };
